export default "__VITE_ASSET__b13506c3__"